import {Component, Input, OnInit} from '@angular/core';
import {Persona} from "../../_models/persona";

@Component({
    selector: 'user-card',
    standalone: false,
    templateUrl: 'card.component.html',
    styleUrls: ['./card.component.scss']
})

export class PersonaCardComponent implements OnInit {

    public _persona: Persona;
    public userImage = false;

    @Input()
    links: any = [];
    @Input()
    set persona(persona: Persona){
        this._persona = persona;
        const objImg = new Image(),
            that = this;
        objImg.src = this._persona.imageUrl;
        objImg.onload = function () {
            that.userImage = true;
        };
    }

    constructor() {
    }

    ngOnInit() {
    }
}
